import { NgModule } from '@angular/core';
import { MapCameraComponent } from './map-camera.component';


@NgModule({
    declarations: [MapCameraComponent],
    exports: [MapCameraComponent],
})
export class MapCameraModule {
}
